<div>
  <span class="print-header">{{ getReferenceSummaryPrintHeader() }}</span>
</div>

<div class="header">
  <div class="guidance-text">
    Use this page to review the status of section, clause, and WSR references both to and from this document. Click
    <a href="https://help.futuredmrb.co.uk/using-the-cars-reference-summary/" target="_blank">here</a> for guidance on
    this feature.
  </div>
  <div class="header-buttons">
    <button
      mat-raised-button
      color="primary"
      (click)="printRoute()"
      aria-label="Print reference summary view"
      enableDefaultFocus
    >
      <mat-icon class="mat-24">print</mat-icon>
      Print
    </button>

    <button
      mat-raised-button
      color="primary"
      (click)="closeRoute()"
      aria-label="Close reference summary view"
      enableDefaultFocus
    >
      <mat-icon class="mat-24">close</mat-icon>
      Close
    </button>
  </div>
</div>

<div class="body-wrapper">
  <div class="body">
    <ng-container *ngIf="loading; else renderTables">
      <div class="loading">
        <div>Loading... this may take some time depending on the size of the document.</div>
        <mat-progress-spinner *ngIf="loading" mode="indeterminate"></mat-progress-spinner>
      </div>
    </ng-container>
    <ng-template #renderTables>
      <div class="title">Other documents that reference this document:</div>
      <ng-container *ngIf="incomingReferences?.length; else noIncomingReferences">
        <cars-reference-summary-table
          [direction]="ReferenceSummaryType.INCOMING"
          [referenceRows]="incomingReferences"
        ></cars-reference-summary-table>
      </ng-container>
      <ng-template #noIncomingReferences>
        <p>There are no documents with clause, section, or WSR references to this document.</p>
      </ng-template>
      <div class="title">Other documents referenced by this document:</div>
      <ng-container *ngIf="outgoingReferences?.length; else noOutgoingReferences">
        <cars-reference-summary-table
          [direction]="ReferenceSummaryType.OUTGOING"
          [referenceRows]="outgoingReferences"
          [fullDocumentTree]="documentFragment"
          (onToggleTargetVersion)="tryRefreshReferencesAndGenerateSummary()"
        ></cars-reference-summary-table>
      </ng-container>
      <ng-template #noOutgoingReferences>
        <p>There are no clause, section, or WSR references to other documents within this document.</p>
      </ng-template>
      <div class="title">Internal references within this document:</div>
      <ng-container *ngIf="sameDocumentReferences?.length; else noSameDocumentReferences">
        <cars-reference-summary-table
          [direction]="ReferenceSummaryType.SAME_DOCUMENT"
          [referenceRows]="sameDocumentReferences"
          [fullDocumentTree]="documentFragment"
        ></cars-reference-summary-table>
      </ng-container>
      <ng-template #noSameDocumentReferences>
        <p>There are no internal clause, section, or WSR references within this document.</p>
      </ng-template>
    </ng-template>
  </div>
</div>
